import { render, staticRenderFns } from "./titleBox.vue?vue&type=template&id=04bfff6e&scoped=true"
import script from "./titleBox.vue?vue&type=script&lang=js"
export * from "./titleBox.vue?vue&type=script&lang=js"
import style0 from "./titleBox.vue?vue&type=style&index=0&id=04bfff6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bfff6e",
  null
  
)

export default component.exports